<template>
  <b-dropdown
    size="xl"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
    @show="showDropdown"
    dropright
    id="dropdown-offset"
    offset="-200"
  >
    <template v-slot:button-content>
      <span :title="`${$t('actionList.actionTable.labels.categoryGroup')}`">
        <i class="table-icons fas fa-tags"></i>
        {{$t('actionTranslateUpdate.options.groupCategory')}}
      </span>
    </template>

    <div v-if="!loading" class="group-div">
      <b-dropdown-text v-for="(group, i) in allGroups" :key="i">
        <div class="custom-control custom-radio my-1 mr-sm-2">
          <input
            type="radio"
            class="custom-control-input"
            :value="group._id"
            :id="`group-${group._id}-${action._id}-${i}`"
            @change="updateGroup(group, action._id)"
            :checked="isCheckedGroup(group._id)"
            :name="`group-${action._id}`"
          />
          <label
            class="custom-control-label"
            :for="`group-${group._id}-${action._id}-${i}`"
          >
            {{ group.name }}
          </label>
        </div>
      </b-dropdown-text>
      <p class="custom-control-label pl-4">
        {{ $t('actionList.registerGroupAction') }}
        <router-link
          :to="{
            name: 'Configurações',
            params: { settings: 'add-category' },
          }"
          class="text-primary"
        >
          {{ $t('actionList.here') }} </router-link
        >.
      </p>
    </div>
    <div v-else>
      <span class="p-3">{{ $t('actionList.loading') }}</span>
    </div>
  </b-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import api from '../../../services/api';

export default {
  props: ['action', 'groupIdList'],

  data: () => ({
    userAuth: null,
    loading: true,
    allGroups: [],
  }),

  computed: {
    ...mapState('companies', ['myMetric']),
    ...mapFields('actions', ['actionGroupData']),
  },

  methods: {
    ...mapActions('actions', ['getAllActions']),

    async updateGroup(group, actionId) {
      try {
        await api.put(
          `${process.env.API_ROOT}/action/${actionId}`,
          { categoryGroupId: group._id },
          { headers: { 'x-access-token': this.userAuth.token } },
        );
        this.action.categoryGroupId = group._id;
        await this.getAllActions({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          params: {
            type: this.myMetric,
            groupId: this.actionGroupData._id,
          },
        });
      } catch (error) {
        window.console.log(error);
      }
    },

    async showDropdown() {
      this.loading = true;
      const response = await api.get('/category-groups', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      for (let i = 0; i < response.data.length; i += 1) {
        if (!response.data[i]._id) {
          response.data.splice(i, 1);
        }
      }
      this.allGroups = response.data;
      this.loading = false;
    },

    isCheckedGroup(group) {
      return this.action.categoryGroupId === group;
    },
  },
  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.table-icons {
  color: $primary;
  font-size: 20px;
  cursor: pointer;

  svg {
    &:hover {
      color: #46b41e;
    }
  }
}

.group-div {
  width: 300px;
  max-height: 250px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/dropdown-category-groups/index.vue